<template lang="pug">
  .component-client-action-buttons
    .dropdown-buttons
      ActionButton(:action="remove", :confirm="true") Delete
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from 'src/maggieHelper'
  import ModalReveal from '../../foundation/ModalReveal'
  import CommonCostButtonModal from './CommonCostButtonModal'
  import ActionButton from '../ActionButton'

  export default {
    name: 'ZoneConfigButtons',
    components: {ActionButton, CommonCostButtonModal, ModalReveal},
    data() {
      return {
        entity: null
      }
    },
    created() {
    },
    methods: {
      remove: function () {
        return KeplerBackofficeSdk.zoneConfigurations.select(this.item).delete(() => {
          MaggieHelper.notification('delete-esit', 'Zone cost deleted')
          this.$emit('itemUpdated')
        })
      },
    },
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// ZoneConfigButtons.vue?6171d1fa